import React from 'react';
// Form
import { useForm } from 'react-hook-form';

// UX
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Button from 'components/Button/Button';

// Styles
import cx from 'classnames';
import requestFormStyles from '../RequestForm.module.scss';
import formStyles from '../../Form.module.scss';
import UploadImage from 'components/UploadImage/UploadImage';

const ReportProblemForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  console.log(errors);

  const onSubmit = () => {
    console.log('submit form');
  };

  return (
    <div className={requestFormStyles['request-form']}>
      <h2 className={formStyles['form-title']}>Report a problem</h2>
      <form
        className={formStyles['form-wrapper']}
        onSubmit={handleSubmit(onSubmit)}
      >
        <FlexContainer width="width-medium" wrap="wrap">
          <div
            className={`${formStyles['form-input-wrapper']} ${formStyles['form-input-description']} ${formStyles['width-large']}`}
          >
            <label className={formStyles['form-input-label']}>
              What is the nasty bug that u found :D?
              <div className={formStyles['form-field-wrapper']}>
                <textarea
                  className={formStyles['form-textarea']}
                  rows="6"
                  cols="50"
                  placeholder="Brat proekta ti kat cqlo e trash"
                  {...register('description', {
                    required:
                      '*Required! The descriptions helps us form the reports',
                  })}
                ></textarea>
              </div>
            </label>
          </div>
        </FlexContainer>
        <FlexContainer width="width-medium">
          <div
            className={`${formStyles['form-input-wrapper']} ${requestFormStyles['form-input-upload-image']} ${formStyles['width-large']}`}
          >
            <label
              className={cx('flex-column', formStyles['form-input-label'])}
            >
              Ako imash snimka na mazniq bug det si fanal, prati mi q brat.
              <div
                className={`${formStyles['form-field-wrapper']} ${requestFormStyles['field-upload-image']}`}
              >
                <UploadImage
                  hasBorder
                  borderRadius="var(--app-general-border-radius-larger)"
                />
              </div>
            </label>
          </div>
        </FlexContainer>

        <div className={formStyles['form-actions-wrapper']}>
          <Button
            clicked={() => console.log('sent information from the form')}
            additionalStyles={requestFormStyles['request-form-submit']}
            type="button-primary-dark"
            text="Request"
          />
        </div>
      </form>
    </div>
  );
};

export default ReportProblemForm;
